export default import.meta.ROLLDOWN_FILE_URL_chdr6_hYXDsxeCCQgt8tTw